module.exports = __webpack_public_path__ + "images/6017fead61793b9f84ab9b92ce7743c1.jpg";